import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import "./style.css";

interface MenuItem {
  id: number;
  title: string;
  link: string;
  submenu?: MenuItem[];
}

const menus: MenuItem[] = [
  {
    id: 1,
    title: "Home",
    link: "/",
  },
  {
    id: 2,
    title: "About",
    link: "#",
    submenu: [
      { id: 21, title: "About Us", link: "/about" },
      { id: 22, title: "Services", link: "/service" },
      { id: 23, title: "Career", link: "/career" },
      { id: 24, title: "Career Details", link: "/career-details" },
      { id: 25, title: "Projects", link: "/project" },
      {
        id: 26,
        title: "Team",
        link: "#",
        submenu: [
         { id: 27, title: "Our Team", link: "/team" },
         { id: 28, title: "Interns", link: "/intern" },
        ],
      },  
    ],
  },
  {
    id: 4,
    title: "Services",
    link: "#",
    submenu: [
      { id: 41, title: "AI SaaS Product", link: "/ai-saas-product" },
      { id: 42, title: "Data & Intelligence", link: "/data-intelligence" },
      { id: 43, title: "AI for E-commerce", link: "/ai-ecommerce" },
      { id: 44, title: "AI Consulting", link: "/ai-consulting" },
      { id: 45, title: "AI Chatbot Virtual", link: "/ai-chatbott" },
      { id: 46, title: "AI Marketing", link: "/ai-markketing" },
      { id: 47, title: "Machine Learning", link: "/machine-learning" },
      { id: 48, title: "AI Integration", link: "/ai-integration" },
    ],
  },
  {
    id: 5,
    title: "Blog",
    link: "/blog",
  },
  {
    id: 6,
    title: "Contact",
    link: "/contact",
  },
];

const MobileMenu: React.FC = () => {
  const [openId, setOpenId] = useState<number | null>(null);
  const [openSubId, setOpenSubId] = useState<number | null>(null);

  const handleToggle = (id: number) => {
    setOpenId(openId === id ? null : id);
    setOpenSubId(null); // close nested when main changes
  };

  const handleSubToggle = (id: number) => {
    setOpenSubId(openSubId === id ? null : id);
  };

  const handleClick = () => {
    setOpenId(null);
    setOpenSubId(null);
    window.scrollTo(0, 0);
  };

  return (
    <ul className="responsivemenu">
      {menus.map((menu) => (
        <li key={menu.id} className={openId === menu.id ? "active" : ""}>
          {menu.submenu ? (
            <Fragment>
              <p onClick={() => handleToggle(menu.id)}>
                {menu.title}
                <i
                  className={
                    openId === menu.id
                      ? "fa fa-angle-up"
                      : "fa fa-angle-down"
                  }
                />
              </p>

              <Collapse in={openId === menu.id} timeout="auto" unmountOnExit>
                <ul className="subMenu">
                  {menu.submenu.map((sub) => (
                    <li key={sub.id}>
                      {sub.submenu ? (
                        <>
                          <p onClick={() => handleSubToggle(sub.id)}>
                            {sub.title}
                            <i
                              className={
                                openSubId === sub.id
                                  ? "fa fa-angle-up"
                                  : "fa fa-angle-down"
                              }
                            />
                          </p>

                          <Collapse
                            in={openSubId === sub.id}
                            timeout="auto"
                            unmountOnExit
                          >
                            <ul className="subMenu nested">
                              {sub.submenu.map((child) => (
                                <li key={child.id}>
                                  <Link
                                    to={child.link}
                                    onClick={handleClick}
                                  >
                                    {child.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </Collapse>
                        </>
                      ) : (
                        <Link to={sub.link} onClick={handleClick}>
                          {sub.title}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </Collapse>
            </Fragment>
          ) : (
            <Link to={menu.link} onClick={handleClick}>
              {menu.title}
            </Link>
          )}
        </li>
      ))}
    </ul>
  );
};

export default MobileMenu;
